/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_Ten_FramesInputs */



/**
* | output |
* | --- |
* | "Forward 10 Frame" |
*
* @param {Shortcut_Keys_Name_Forward_Ten_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_ten_frames = /** @type {((inputs?: Shortcut_Keys_Name_Forward_Ten_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_Ten_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de 10 images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorwärts 10 Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti 10 fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вперед 10 кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar 10 cuadros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前进 10 帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("10フレーム進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आगे 10 फ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quadro 10 para frente")
	return /** @type {LocalizedString} */ ("Forward 10 Frame")
});